import React from 'react'
import InfoPopup from './InfoPopup'

const EditReportLayout = ({ children }) => {
    // const { notificationQueue } = useContext(ReportingContext)
    // const [notification, setNotification] = useState(null)

    // const visibleNotifications = useMemo(() => {
    //     return notificationQueue.filter(notification =>
    //         notification.id !== fetchingReportPreview.id
    //     )
    // }, [notificationQueue])

    // useEffect(() => {
    //     if (visibleNotifications.length > 0) {
    //         setNotification(visibleNotifications[0])
    //     }
    // }, [visibleNotifications])

    return (
        <div className="section reportTableSection">
            {/* {visibleNotifications.map((notification) => {
                return (
                    <Notification
                        key={notification.id}
                        message={notification.message}
                        type={notification.type}
                    />
                )
            })} */}
            {children}
            <InfoPopup />
        </div>
    )
}

export default EditReportLayout
